import { FC, useEffect } from "react";
import "../CSS/CalendarDetailScreen.css";
import backIcon from "../../../assets/images/back-icon.svg";
import locationIcon from "../../../assets/images/location-icon.svg";
import bannerImage from "../../../assets/images/real-life-images/communicate-space-image-1.png";
import { useNavigate } from "react-router-dom";
import ImageCarousel from "components/elements/ImageCarousel";
import { MEMBER_BENEFITS_TYPE } from "utils/constants";
import { getMemberBenefitsRealLifeImages } from "utils/utils";
import { WEB_LINK } from "utils/strings";
import { useLogout } from "services/LogoutProvider";
import ROUTE_PATHS from "utils/routePaths";
import { trackDetailView } from "utils/analytics";

const TheFoundryDetailScreen: FC = () => {
  const navigate = useNavigate();
  const { handleAppExit } = useLogout();

  useEffect(() => {
    trackDetailView("events", "EVENTS");
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleReserveClick = () => {
    navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
      state: {
        anyData: {
          title: "The Foundry",
          url: WEB_LINK.THE_FOUNDRY_DETAIL,
        },
      },
    });
  };

  const openWorkspaceLocation = () => {
    handleAppExit(WEB_LINK.SABE_LOCATION);
  };

  return (
    <div className="wms-mobile-container">
      <div className="calendar_detail-screen-container">
        <div className="calendar_detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <span>
            The <span style={{ color: "#ff6b35" }}>Foundry</span>
          </span>
        </div>
        <div
          className="calendar-detail-banner-image-container"
          style={{ backgroundImage: `url(${bannerImage})` }}
        ></div>
        <div className="calendar_detail-date-location-container">
          <div className="detail-container">
            <div className="image">
              <img src={locationIcon} alt="location-logo" />
            </div>
            <div className="right-container">
              <div className="sub-container">
                <span>Sabe Hub, Mohali</span>
                <span className="sub-text">Floor 1</span>
              </div>
              <button onClick={openWorkspaceLocation}>Direction</button>
            </div>
          </div>
        </div>
        <div className="calendar_detail-container">
          <span>
            About <span style={{ color: "#ff6b35" }}>The Foundry</span>
          </span>
          <div className="divider"></div>
          <div className="sub-title">
            The Foundry is SabeHub's private membership community for founders
            and business owners.
            <br />
            <br />
            We help serious builders work better, think clearer, meet the right
            people, and grow inside a system designed for business and life.
            <br />
            <br />
            Not coworking
            <br />
            Not casual networking
            <br />A better way to build
          </div>
        </div>
        <div className="calendar_detail-contact-detail-container">
          <ImageCarousel
            images={getMemberBenefitsRealLifeImages(
              MEMBER_BENEFITS_TYPE.EVENTS,
            )}
            title="In Real"
            subTitle="Life"
          />
        </div>
        <button
          className="calendar_detail-reserve-btn"
          onClick={handleReserveClick}
        >
          Become a member
        </button>
      </div>
    </div>
  );
};

export default TheFoundryDetailScreen;